<script>
  import LegendBubble from './LegendBubble.svelte';

  import { isSmallScreen, opacityScale } from '../utils';
  import { activeCategory, activeCategoryItem } from '../stores';

  import {
    bubbleMinRadius,
    bubbleMedRadius,
    bubbleMaxRadius,
    articleLegendItems
  } from '../config';

  const displaySourceModal = () => {
    document.getElementById("source__modal").style.display = "block";
    document.body.style.overflow = "hidden";
  }

  const closeSourceModal = () => {
    document.getElementById("source__modal").style.display = "none";
    document.body.style.overflow = "auto";
  }
</script>

<style>
  .km-legend {
    margin-left: auto;
    font-size: 12px;
    display: flex;
    flex-direction: column;
  }

  .km-legend__items {
    display: flex;
  }

  .km-legend .km-legend__item:first-child {
    margin-right: 20px;
  }

  .km-title {
    margin-bottom: 10px;
  }

  .km-bubbles__weight {
    position: relative;
  }

  .km-bubbles__weight .km-item {
    position: absolute;
    bottom: 0;
  }

  .km-bubbles__weight :global(.km-bubble) {
    position: relative;
  }

  .km-bubbles__weight .km-label {
    position: absolute;
    left: 60px;
    top: -5px;
  }

  .km-bubbles__articles {
    display: flex;
  }

  .km-bubbles__articles .km-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 30px;
  }

  .km-bubbles__articles :global(.km-bubble) {
    margin-bottom: 5px;
  }

  .km-source {
    cursor: pointer;
    color: #888;
    margin-top: 10px;
    align-self: flex-start;
  }

  .km-source:hover {
    opacity: 0.8;
  }

  #source__modal {
    display: none;
    width: 100%;
    position: fixed;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0,0,0,.7);
    z-index: 5000;
  }

  .km-modal-inner {
    position: fixed;
    background: #fff;
    width: 50vw;
    height: 80vh;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 300px;
  }

  .km-modal-text {
    height: 100%;
    overflow: auto;
    padding: 0 25px;
    font-weight: 500;
  }

  .km-modal-close-btn {
    position: absolute;
    height: 3vw;
    width: 3vw;
    border: none;
    border-radius: 50% !important;
    background: #f3f3f3;
    color: black;
    line-height: 2.3vw;
    font-size:calc(10px + 2vw);
    right: -1vw;
    top: -1vw;
    cursor: pointer;
    text-align: center;
    min-width: 25px;
    min-height: 25px;
    padding: 0;
  }
  .km-modal-close-btn:focus {
    outline: 0;
  }

  @media screen and (min-width: 800px) {
    .km-bubbles__weight .km-label {
      top: 0;
    }

    .km-source {
      align-self: flex-end;
    }
  }
</style>

<div class="km-legend">
  <div class="km-legend__items">
    <div class="km-legend__item">
      <div class="km-title">
        Gewicht aller
        <br />
        importierten Artikel
        <br />
        (01.11.18 - 17.06.20)
      </div>
      <div class="km-bubbles__weight" style="height: {bubbleMaxRadius * 2}px">
        <div class="km-item">
          <LegendBubble
            size={bubbleMaxRadius * 2}
            color={$activeCategoryItem.color}
            opacity={0.5} />

          <div class="km-label">280&nbsp;t</div>
        </div>
        {#if !isSmallScreen}
          <div class="km-item">
            <LegendBubble
              size={bubbleMedRadius * 2}
              color={$activeCategoryItem.color}
              opacity={0}
              style="left: {bubbleMaxRadius - bubbleMedRadius}px" />
            <div class="km-label">70&nbsp;t</div>
          </div>
        {/if}
        <div class="km-item">
          <LegendBubble
            size={bubbleMinRadius * 2}
            color={$activeCategoryItem.color}
            opacity={0}
            style="left: {bubbleMaxRadius - bubbleMinRadius}px" />
          <div class="km-label">400&nbsp;kg</div>
        </div>
      </div>
    </div>
    <div class="km-legend__item">
      <div class="km-title">
        Anteil
        <br />
        importierter Artikel
      </div>
      <div class="km-bubbles__articles">
        {#each articleLegendItems as item}
          <div class="km-item">
            <LegendBubble
              size={14}
              color={$activeCategoryItem.color}
              opacity={opacityScale(item / 100)} />
            <div>{item}%</div>
          </div>
        {/each}
      </div>
    </div>
  </div>
  <div on:click={displaySourceModal} class="km-source" id="koromap__legend">Quellen & Infos</div>
  <div id="source__modal">
    <div class="km-modal-inner">
      <button on:click={closeSourceModal} class="km-modal-close-btn">×</button>
      <div class="km-modal-text">
        <h2>Was die Weltkarte zeigt</h2>
        <p>Die Karte zeigt, von wo wir bei KoRo unsere Produkte beziehen. Neben der Information zum Ursprungsland gibt es auch die Informationen, in welcher Menge und auf welchem Weg die Produkte zu uns nach Berlin kommen. Die Produkte weltweit lassen sich nach unseren Produktkategorien filtern oder direkt über die Suchleiste finden. Die Größe der einzelnen Kreise spiegelt das Gewicht der aus diesem Land importierten Produkte wider und deren Farbe dessen Anteil an den gesamten Importen. Die Datenbasis sind sämtliche Lieferungen vom 01.11.2018 bis 17.6.2020.</p>
        <h2>Disclaimer</h2>
        <p>Bei Produkten, die wir bereits verarbeitet beziehen und bei denen Zutaten aus mehreren Ländern stammen, haben wir die bezogene Menge auf die entsprechenden Ursprungsländer gleichverteilt.<p>
        <p>Zwischen bestellter Rohware und Endprodukt kann es zu einem Schwund von 2-10% kommen.</p>
      </div>
    </div>
  </div>
</div>
